/* tslint:disable:max-line-length */
import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  consentHeader: {
    defaultMessage: 'Do you want to stay connected to {providerName}?',
    id: 'ExtendConsent.consentHeader',
  },
  consentBody: {
    defaultMessage: 'This permits us to access these data points for 90 more days:',
    id: 'ExtendConsent.consentBody',
  },
  confirm: {
    defaultMessage: 'Confirm',
    id: 'ExtendConsent.confirm',
  },
});
